"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getBookingsForAnalysisUrl = require("./get-bookings-for-analysis-url.dto");
Object.keys(_getBookingsForAnalysisUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getBookingsForAnalysisUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getBookingsForAnalysisUrl[key];
    }
  });
});
var _getBookingsWithOutstandingBalancesUrl = require("./get-bookings-with-outstanding-balances-url.dto");
Object.keys(_getBookingsWithOutstandingBalancesUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getBookingsWithOutstandingBalancesUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getBookingsWithOutstandingBalancesUrl[key];
    }
  });
});
var _getClinicianProfileUrl = require("./get-clinician-profile-url.dto");
Object.keys(_getClinicianProfileUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getClinicianProfileUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getClinicianProfileUrl[key];
    }
  });
});
var _getCliniciansForMatchingUrl = require("./get-clinicians-for-matching-url.dto");
Object.keys(_getCliniciansForMatchingUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getCliniciansForMatchingUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getCliniciansForMatchingUrl[key];
    }
  });
});
var _getMedicationsProviderUrl = require("./get-medications-provider-url.dto");
Object.keys(_getMedicationsProviderUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getMedicationsProviderUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getMedicationsProviderUrl[key];
    }
  });
});
var _getOnboardingReviewIntake = require("./get-onboarding-review-intake.dto");
Object.keys(_getOnboardingReviewIntake).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getOnboardingReviewIntake[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getOnboardingReviewIntake[key];
    }
  });
});
var _getPatientBookingsUrl = require("./get-patient-bookings-url.dto");
Object.keys(_getPatientBookingsUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPatientBookingsUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getPatientBookingsUrl[key];
    }
  });
});
var _getPatientCareTeamUrl = require("./get-patient-care-team-url.dto");
Object.keys(_getPatientCareTeamUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPatientCareTeamUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getPatientCareTeamUrl[key];
    }
  });
});
var _getPatientNotesUrl = require("./get-patient-notes-url.dto");
Object.keys(_getPatientNotesUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPatientNotesUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getPatientNotesUrl[key];
    }
  });
});
var _getPatientProfileUrl = require("./get-patient-profile-url.dto");
Object.keys(_getPatientProfileUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPatientProfileUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getPatientProfileUrl[key];
    }
  });
});
var _getPostAppointmentClinicianStateUrl = require("./get-post-appointment-clinician-state-url.dto");
Object.keys(_getPostAppointmentClinicianStateUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPostAppointmentClinicianStateUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getPostAppointmentClinicianStateUrl[key];
    }
  });
});
var _getPostAppointmentStateUrl = require("./get-post-appointment-state-url.dto");
Object.keys(_getPostAppointmentStateUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPostAppointmentStateUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getPostAppointmentStateUrl[key];
    }
  });
});
var _getSessionNotesUrl = require("./get-session-notes-url.dto");
Object.keys(_getSessionNotesUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getSessionNotesUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getSessionNotesUrl[key];
    }
  });
});
var _getSurveyUrl = require("./get-survey-url.dto");
Object.keys(_getSurveyUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getSurveyUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getSurveyUrl[key];
    }
  });
});
var _postSessionNotesUrl = require("./post-session-notes-url.dto");
Object.keys(_postSessionNotesUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _postSessionNotesUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _postSessionNotesUrl[key];
    }
  });
});
var _recommendationResult = require("./recommendation-result.dto");
Object.keys(_recommendationResult).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _recommendationResult[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _recommendationResult[key];
    }
  });
});
var _suggestedClinician = require("./suggested-clinician.dto");
Object.keys(_suggestedClinician).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _suggestedClinician[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _suggestedClinician[key];
    }
  });
});
var _getMyBookingsMissingSubjectiveNotesUrl = require("./get-my-bookings-missing-subjective-notes-url.dto");
Object.keys(_getMyBookingsMissingSubjectiveNotesUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getMyBookingsMissingSubjectiveNotesUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getMyBookingsMissingSubjectiveNotesUrl[key];
    }
  });
});